import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Background, Hr, Titulo, Input, Row, Table, Button } from "./style";
import api from "../../../services/api";
import { Swal, Toast } from "../../../services/SwalTemplates";
import Pagination from "../../../components/Pagination";
import Auth from "../../../services/auth";
import config from "../../../assets/json/texts.json";

const { STATIC_URL_DEV, STATIC_URL_PROD } = config;

export default function Consulta() {
  const [auth] = useState(Auth.auth());
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [professores, setProfessores] = useState([]);
  const [professor, setProfessor] = useState("");
  const [matricula, setMatricula] = useState(999999);
  const [consulta, setConsulta] = useState([]);

  useEffect(() => {
    api
      .get(`/coord/contributors?inativo=${false}`)
      .then((response) => {
        setProfessores(response.data.colaboradores);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
  }, [navigate]);

  useEffect(() => {
    api
      .get(`/coord/turmacolaborador?matricula=${matricula}&consulta=${true}`)
      .then((response) => {
        setConsulta(response.data.turma_colaborador[0]);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
  }, [navigate, matricula]);

  useEffect(() => {
    setTotalPages(Math.ceil(consulta.length / 15));
  }, [consulta]);

  async function handleExcel(matricula) {
    const response = await api.post(`/coord/contributorsxlsx?matricula=${matricula}`);
    if (response.data.error) {
      return Swal.fire("Criação não permitida!", response.data.error, "warning");
    }
    Toast.fire({
      icon: "success",
      title: "Gerado com sucesso!",
    });
    window.open(
      window.location.href.includes("localhost")
        ? `${STATIC_URL_DEV}/colaboradoreslancamento?auth=${auth}`
        : `${STATIC_URL_PROD}/colaboradoreslancamento?auth=${auth}`
    );
    // setCustos(custos.filter((custo) => custo.id !== id));
  }

  const cargas = consulta?.map((c) => c.carga) || 0;
  const totalhrs = cargas?.reduce((acc, curr) => Number(acc) + Number(curr), 0);

  return (
    <Background>
      <Container>
        <Titulo>Consulta de Horários</Titulo>
        <Hr />
        <Row>
          <Input>
            <div style={{ display: "flex" }}>
              <select
                value={professor}
                onChange={(e) => {
                  setProfessor(e.target?.value?.toUpperCase());
                  setMatricula(e.target[e.target.options.selectedIndex]?.id);
                  setPage(1);
                }}
              >
                <option disabled value="">
                  Selecione o professor
                </option>
                {professores.map((p, i) => (
                  <option key={i} id={p.matricula} title={p.matricula}>
                    {p.nome}
                  </option>
                ))}
              </select>
              <Button
                onClick={() => {
                  handleExcel(matricula);
                }}
                style={{
                  cursor: "pointer",
                  opacity: 1,
                  pointerEvents: "auto",
                }}
              >
                Gerar planilha
              </Button>
            </div>
          </Input>
        </Row>
        <Table>
          <table>
            <thead>
              <tr>
                <th>Dia Semana</th>
                <th>Unidade</th>
                <th>Turma</th>
                <th>Horário Início</th>
                <th>Horário Término</th>
                <th>Carga Horária</th>
              </tr>
            </thead>
            <tbody>
              {consulta.slice((page - 1) * 15, page * 15).map((c, i) => (
                <tr key={i}>
                  <td data-title="Dia da semana" value={c.nome}>
                    {c.dia_semana}
                  </td>
                  <td data-title="Unidade" value={c.nome}>
                    {c.unidade}
                  </td>
                  <td data-title="Turma" value={c.id} className="td-left">
                    {c.turma.replaceAll("TÉCNICO EM ", "").replaceAll("CURSO TÉCNICO ", "").replaceAll("TECNÓLOGO EM ", "")}
                  </td>
                  <td data-title="Horário Início" value={c.nome}>
                    {c.horario_inicio}
                  </td>
                  <td data-title="Horário Fim" value={c.nome}>
                    {c.horario_fim}
                  </td>
                  <td data-title="Carga Horária" value={c.nome}>
                    {c.carga}
                  </td>
                </tr>
              ))}
              {consulta.length > 0 && (
                <tr>
                  <td style={{ border: 0, backgroundColor: "#fff", padding: 0 }} colSpan={4}></td>
                  <td>
                    <strong>Carga Horária Total:</strong>
                  </td>
                  <td>{totalhrs}</td>
                </tr>
              )}
            </tbody>
          </table>
        </Table>
        <Pagination page={page} setPage={setPage} totalPages={totalPages} />
      </Container>
    </Background>
  );
}
